import * as React from 'react';
import {Link} from "react-router-dom";

export const AdminPage = () => {
    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">Home</li>
                </ol>
            </nav>

            <h3 className={'pt-4'}>Welcome to Root Admin Panel</h3>

            <div className="list-group admin-list mt-4">
                <Link className="list-group-item list-group-item-action" to="/stats-overview">
                    <strong>Stats Overview</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/dashboards">
                    <strong>Roles & Dashboards</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/courses">
                    <strong>Courses</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/languages">
                    <strong>Languages</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/content-editing">
                    <strong>Global Content Editing</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/user-management">
                    <strong>User Management</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/user-stats">
                    <strong>User Stats</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to="/release-mnemo">
                    <strong>Mnemo Cards Release</strong>
                </Link>
            </div>
        </div>
    </div>
};
